// src/js/components/slider-dots.js
var SliderDots = class extends HTMLElement {
  /**
   * Construct
   */
  constructor() {
    super();
    this.selector = {
      button: ".slider-bar",
      sliderItems: '[id^="Slide-"]',
      currentIndex: ".slider-counter--current"
    };
    setTimeout(() => this.init(), 1e3);
  }
  /**
   * Init
   */
  init() {
    this.sliderComponent = this.parentElement;
    this.sliderItems = this.sliderComponent.querySelectorAll(this.selector.sliderItems);
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    this.sliderItemOffset = this.sliderItemsToShow[1]?.offsetLeft - this.sliderItemsToShow[0]?.offsetLeft;
    this.currentIndexEl = this.parentElement.querySelector(this.selector.currentIndex);
    this.buttons = this.querySelectorAll(this.selector.button);
    this.buttons?.forEach((button, index) => {
      button?.addEventListener("click", () => {
        this.handleClick(button, index);
      });
    });
    this.sliderComponent?.addEventListener("slideChanged", (event) => {
      this.updateActiveButton(event.detail.currentPage);
    });
  }
  /**
   * Handle Click
   * 
   * @param {Element} clickedButton 
   * @param {int} index 
   */
  handleClick(clickedButton, index) {
    const activeButton = this.querySelector(`${this.selector.button}.active`);
    if (void 0 === activeButton || clickedButton === activeButton) {
      return;
    }
    const activeIndex = activeButton.dataset.count;
    const clickedIndex = clickedButton.dataset.count;
    const step = clickedIndex - activeIndex;
    this.sliderComponent.setSlidePosition(step);
  }
  /**
   * Update Active Button
   * 
   * @param {Element} newActiveButton 
   */
  updateActiveButton(index) {
    this.buttons.forEach((button) => {
      button.classList.remove("active");
    });
    this.querySelector(`.slider-bar[data-count="${index}"]`)?.classList.add("active");
  }
};
customElements.define("slider-dots", SliderDots);
